import React, { useState } from "react";
import { Card, Row, Col, Dropdown, Modal, Button } from "react-bootstrap";
import { BsThreeDotsVertical } from "react-icons/bs";
import { FiEdit, FiTrash } from "react-icons/fi";
import EditEmployeeModal from "../../modals/hrm/employee/EditEmployeeModal";
import { Link } from "react-router-dom";
import DeleteEmployeeModal from "../../modals/hrm/employee/DeleteEmployeeModal";
export default function EmployeesGrid() {

       const [showEditUser, setShowEditUser] = useState(false);
       const [deleteUser, setDeleteUser] = useState(false);
         const [showEdit, setShowEdit] = useState(false);
         const [showDelete, setShowDelete] = useState(false);
  // ✅ 8 items (2 rows)
  const data = [
    {
      name: "Anthony Lewis",
      role: "Software Developer",
      img: "/assets/img/users/user-32-1.jpg",
      projects: 20,
      done: 13,
      progress: 7,
      productivity: 65,
      color: "#a855f7"
    },
    {
      name: "Brian Villalobos",
      role: "Developer",
      img: "/assets/img/users/user-09.jpg",
      projects: 30,
      done: 10,
      progress: 20,
      productivity: 30,
      color: "#facc15"
    },
    {
      name: "Harvey Smith",
      role: "Developer",
      img: "/assets/img/users/user-01-1.jpg",
      projects: 25,
      done: 7,
      progress: 18,
      productivity: 20,
      color: "#ef4444"
    },
    {
      name: "Stephan Peralt",
      role: "Software Developer",
      img: "/assets/img/users/user-33-1.jpg",
      projects: 15,
      done: 13,
      progress: 2,
      productivity: 90,
      color: "#22c55e"
    },
    {
      name: "John Carter",
      role: "Executive",
      img: "/assets/img/users/user-05.jpg",
      projects: 18,
      done: 10,
      progress: 8,
      productivity: 55,
      color: "#3b82f6"
    },
    {
      name: "David Miller",
      role: "Finance",
      img: "/assets/img/users/user-06.jpg",
      projects: 22,
      done: 12,
      progress: 10,
      productivity: 60,
      color: "#f97316"
    },
    {
      name: "Emma Watson",
      role: "Developer",
      img: "/assets/img/users/user-07.jpg",
      projects: 28,
      done: 18,
      progress: 10,
      productivity: 70,
      color: "#10b981"
    },
    {
      name: "Sophia Lee",
      role: "Executive",
      img: "/assets/img/users/user-08.jpg",
      projects: 12,
      done: 6,
      progress: 6,
      productivity: 50,
      color: "#ec4899"
    }
  ];
const handleDelete = () => {
   data()
    console.log('Items deleted');
    setShowDelete(false);
  };
  return (
    

  <Row className="mt-3" >
         {/* HEADER */}
    <Card className="p-3 mt-3 mx-3" >
       <div className="d-flex justify-content-between align-items-center flex-wrap mb-3">
        <h5 className="mb-0">Employees Grid</h5>

        <div className="d-flex gap-2 flex-wrap">

          {/* DESIGNATION */}
          <Dropdown>
            <Dropdown.Toggle className=" rounded rounded-2 border border-1 bg-white text-dark">
              Designation
            </Dropdown.Toggle>

            <Dropdown.Menu className="dropdown-ui">
              <Dropdown.Item>Finance</Dropdown.Item>
              <Dropdown.Item>Developer</Dropdown.Item>
              <Dropdown.Item>Executive</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>

          {/* SORT */}
          <Dropdown>
            <Dropdown.Toggle className=" rounded rounded-2 border border-1 bg-white text-dark">
              Sort By : Last 7 Days
            </Dropdown.Toggle>

            <Dropdown.Menu className="dropdown-ui">
              <Dropdown.Item>Recently Added</Dropdown.Item>
              <Dropdown.Item>Ascending</Dropdown.Item>
              <Dropdown.Item>Descending</Dropdown.Item>
              <Dropdown.Item>Last Month</Dropdown.Item>
              <Dropdown.Item>Last 7 Days</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>

        </div>
      </div>

    </Card>
      {/* GRID */}
  
        <Row className="mt-3 ms-1"  >  
        {data.map((item, i) => (
          <Col lg={3} md={6} sm={12} key={i} className="mb-3">

            <Card className="employee-card">

              {/* TOP */}
              <div className="d-flex justify-content-between align-items-center">
                <input type="checkbox" />
<Dropdown align="end">
  <Dropdown.Toggle
    as="div"
    className="menu-icon-only"
  >
    <BsThreeDotsVertical />
  </Dropdown.Toggle>

  <Dropdown.Menu className="dropdown-ui action-menu">
    <Dropdown.Item onClick={()=>setShowEdit(true)} className="d-flex align-items-center gap-2">
      <FiEdit     /> Edit
    </Dropdown.Item>

    <Dropdown.Item onClick={()=>setShowDelete(true)} className="d-flex align-items-center gap-2">
      <FiTrash     /> Delete
    </Dropdown.Item>
  </Dropdown.Menu>
</Dropdown>
              </div>

              {/* PROFILE */}
              <div className="text-center mt-2">
                <div className="avatar-wrapper">

                                                        <Link  className="text-decoration-none text-dark" to="/employees-details" >
              <img src={item.img} className="avatar-img" alt="" />
                  <span className="online-dot"></span>

</Link>
                  
                </div>
                                      <Link  className="text-decoration-none text-dark" to="/employees-details" >
                <h6 className="mt-2">{item.name}</h6>

</Link>

                <span className="role-badge">{item.role}</span>
              </div>

              {/* STATS */}
              <div className="d-flex justify-content-between mt-3 text-center">
                <div>
                  <small>Projects</small>
                  <div>{item.projects}</div>
                </div>
                <div>
                  <small>Done</small>
                  <div>{item.done}</div>
                </div>
                <div>
                  <small>Progress</small>
                  <div>{item.progress}</div>
                </div>
              </div>

              {/* PRODUCTIVITY */}
              <div className="mt-3">
                <small>
                  Productivity :{" "}
                  <span style={{ color: item.color }}>
                    {item.productivity}%
                  </span>
                </small>

                <div className="progress mt-1">
                  <div
                    className="progress-bar"
                    style={{
                      width: `${item.productivity}%`,
                      background: item.color
                    }}
                  ></div>
                </div>
              </div>

            </Card>

          </Col>
        ))}
      </Row>

        {/* CSS */}
      <style>
        {`
  body {
          background: #f8fafc;
        }

        .employee-card {
          padding: 18px;
          border-radius: 7px;
          border: 2px solid #e5e7eb;
          box-shadow: 0 2px 6px rgba(0,0,0,0.04);
        }

        .card-top {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        .avatar-wrapper {
          position: relative;
          width: 80px;
          margin: auto;
        }

        .avatar-img {
          width: 80px;
          height: 80px;
          border-radius: 50%;
          border: 3px solid #f26522;
        }

        .online-dot {
          width: 10px;
          height: 10px;
          background: #22c55e;
          border-radius: 50%;
          position: absolute;
          bottom: 5px;
          right: 5px;
          border: 2px solid #fff;
        }

        .role-badge {
          background: #f3e8ff;
          color: #a855f7;
          padding: 4px 10px;
          border-radius: 6px;
          font-size: 12px;
        }

        .progress {
          height: 6px;
          background: #eee;
          border-radius: 10px;
        }

        .menu-btn {
       background: #ffffff;
          border: none;
          color: #fff;
          border-radius: 50%;
          width: 32px;
          height: 32px;
        }

        .dropdown-ui {
          padding: 10px;
          border-radius: 10px;
        }

        .dropdown-ui .dropdown-item:hover {
          background: #f26522 !important;
          color: #fff !important;
        }

        .btn-white {
          background: #fff !important;
          border: 1px solid #e5e7eb !important;
        }
          .btn-white:hover {
          // background: #fff !important;
                   color: #fff !important;


          }
/* 🔥 FORCE CLEAN ICON BUTTON */
.menu-icon-only {
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
  padding: 4px;
  color: #111827;
}

/* REMOVE ALL STATES */
.menu-icon-only:hover,
.menu-icon-only:focus,
.menu-icon-only:active {
  background: transparent !important;
  box-shadow: none !important;
  color: #111827 !important;
}

/* REMOVE BOOTSTRAP ARROW */
.menu-icon-only::after {
  display: none !important;
}

/* ICON SIZE */
.menu-icon-only svg {
  font-size: 18px;
}
        @media (max-width: 768px) {
          .employee-card {
            text-align: center;
          }
        }
        `}
      </style>

            {/* EDIT MODAL */}
      {/* <EditEmployeeModal show={showEditUser} onHide={()=>setShowEditUser(false)} /> */}
 <EditEmployeeModal
   show={showEdit}
   handleClose={() => setShowEdit(false)}
 />

      {/* DELETE MODAL */}

      <DeleteEmployeeModal
        showDelete={showDelete}
        setShowDelete={setShowDelete}
        onConfirmDelete={handleDelete}
      />

    
  </Row>

    


  );
}